require('svg4everybody')({});
